import { render, staticRenderFns } from "./GreenFitOutActionBtns.vue?vue&type=template&id=23974898&scoped=true&"
import script from "./GreenFitOutActionBtns.vue?vue&type=script&lang=js&"
export * from "./GreenFitOutActionBtns.vue?vue&type=script&lang=js&"
import style0 from "./GreenFitOutActionBtns.vue?vue&type=style&index=0&id=23974898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23974898",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23974898')) {
      api.createRecord('23974898', component.options)
    } else {
      api.reload('23974898', component.options)
    }
    module.hot.accept("./GreenFitOutActionBtns.vue?vue&type=template&id=23974898&scoped=true&", function () {
      api.rerender('23974898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/greenFitOut/GreenFitOutActionBtns.vue"
export default component.exports